import { Box, Divider, Hidden, Page, PageBlock } from 'braid-design-system';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import CustomLoader from 'src/components/CustomLoader/CustomLoader';
import Header from 'src/components/Header/Header';
import { SiteWideFooter } from 'src/components/SiteWideFooter';
import { useCommand } from 'src/hooks/command';
import { unsubscribeUser } from 'src/services/api';
import Confirmation from 'src/views/Unsubscribe/components/Confirmation';

const Unsubscribe = () => {
  const { commandStatus: unsubscribeStatus, command: unsubscribe } =
    useCommand(unsubscribeUser);

  const { id } = useParams();
  useEffect(() => {
    unsubscribe(id);
  });

  const params =
    unsubscribeStatus === 'SUCCESS'
      ? {
          title: "You've been unsubscribed",
          cardTitle: 'Your inbox is a little lighter',
          body: 'Call customer service on 13 73 35 (Mon - Fri, 9am - 5pm AEST) if we can help you with anything else.',
        }
      : {
          title: 'Something went wrong',
          cardTitle: 'You have not been unsubscribed from this email',
          body: 'Contact customer service on 13 73 35 (Mon - Fri, 9am - 5pm AEST) for help.',
        };

  return (
    <Page footer={<SiteWideFooter />} footerPosition="belowFold">
      <Header title="Buying a business" />

      <Hidden below="tablet">
        <Divider />
      </Hidden>

      <Box paddingTop="xlarge">
        <PageBlock width="small">
          {unsubscribeStatus === 'LOADING' ? (
            <CustomLoader />
          ) : (
            <Confirmation {...params} />
          )}
        </PageBlock>
      </Box>
    </Page>
  );
};

export default Unsubscribe;
